// ----------------------------------------------------------------------

function pxToRem(value) {
  return `${value / 16}rem`
}

function responsiveFontSizes({ sm, md, lg }) {
  return {
    '@media (min-width:600px)': {
      fontSize: pxToRem(sm),
    },
    '@media (min-width:900px)': {
      fontSize: pxToRem(md),
    },
    '@media (min-width:1200px)': {
      fontSize: pxToRem(lg),
    },
  }
}

// Same families as lidyagenomics.com: Geist for reading, Geist Mono for scientific
// data (coordinates, HGVS, transcript and sample IDs). Loaded in public/index.html.
export const FONT_PRIMARY = `"Geist", ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, sans-serif`
export const FONT_MONO = `"Geist Mono", ui-monospace, "SFMono-Regular", "SF Mono", Menlo, Consolas, monospace`

const typography = {
  fontFamily: FONT_PRIMARY,
  fontFamilyMono: FONT_MONO,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 600,
  h1: {
    fontWeight: 600,
    lineHeight: 1.15,
    letterSpacing: '-0.02em',
    fontSize: pxToRem(36),
    ...responsiveFontSizes({ sm: 40, md: 44, lg: 48 }),
  },
  h2: {
    fontWeight: 600,
    lineHeight: 1.2,
    letterSpacing: '-0.02em',
    fontSize: pxToRem(30),
    ...responsiveFontSizes({ sm: 32, md: 34, lg: 36 }),
  },
  h3: {
    fontWeight: 600,
    lineHeight: 1.25,
    letterSpacing: '-0.015em',
    fontSize: pxToRem(24),
    ...responsiveFontSizes({ sm: 26, md: 28, lg: 28 }),
  },
  h4: {
    fontWeight: 600,
    lineHeight: 1.3,
    letterSpacing: '-0.01em',
    fontSize: pxToRem(20),
    ...responsiveFontSizes({ sm: 22, md: 22, lg: 22 }),
  },
  h5: {
    fontWeight: 600,
    lineHeight: 1.4,
    letterSpacing: '-0.01em',
    fontSize: pxToRem(18),
    ...responsiveFontSizes({ sm: 18, md: 18, lg: 18 }),
  },
  h6: {
    fontWeight: 600,
    lineHeight: 1.45,
    letterSpacing: '-0.005em',
    fontSize: pxToRem(16),
    ...responsiveFontSizes({ sm: 16, md: 16, lg: 16 }),
  },
  subtitle1: {
    fontWeight: 600,
    lineHeight: 1.5,
    fontSize: pxToRem(16),
  },
  subtitle2: {
    fontWeight: 600,
    lineHeight: 1.5,
    fontSize: pxToRem(14),
  },
  body1: {
    lineHeight: 1.6,
    fontSize: pxToRem(16),
    letterSpacing: '0.003em',
  },
  body2: {
    lineHeight: 1.55,
    fontSize: pxToRem(14.5),
    letterSpacing: '0.003em',
  },
  caption: {
    lineHeight: 1.5,
    fontSize: pxToRem(13),
    letterSpacing: '0.005em',
  },
  overline: {
    fontWeight: 600,
    lineHeight: 1.5,
    fontSize: pxToRem(11.5),
    letterSpacing: '0.06em',
    textTransform: 'uppercase',
  },
  // Data-table roles. 12px is the floor for anything a reader has to read.
  tableHead: {
    fontWeight: 600,
    lineHeight: 1.4,
    fontSize: pxToRem(13),
    letterSpacing: '0.01em',
  },
  dataCell: {
    lineHeight: 1.5,
    fontSize: pxToRem(13.5),
    fontVariantNumeric: 'tabular-nums',
  },
  dataCellDense: {
    lineHeight: 1.45,
    fontSize: pxToRem(12.5),
    fontVariantNumeric: 'tabular-nums',
  },
  mono: {
    fontFamily: FONT_MONO,
    lineHeight: 1.5,
    fontSize: pxToRem(13),
    fontVariantNumeric: 'tabular-nums',
  },
  button: {
    fontWeight: 600,
    lineHeight: 24 / 14,
    fontSize: pxToRem(14),
    letterSpacing: 0,
    textTransform: 'none',
  },
}

export default typography
